import React from 'react';
import classnames from 'classnames/bind';

import styles from './tabbedNavStyles';

class TabbedNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: props.initialTabIndex || 0
    };
    this.changeNavItem = this.changeNavItem.bind(this);
  }

  changeNavItem(tab, tabIndex) {
    this.setState({ activeTabIndex: tabIndex });
    if (this.props.onChange) {
      this.props.onChange(tab);
    }
  }

  render() {
    const tabs = this.props.tabs || [];
    const cx = classnames.bind(styles);

    return (
      <ul className={styles.tabbedNav}>
        {tabs.map((tab, idx) => {
          const listItemClassName = cx('tabbedNavItem', {
            active: idx === this.state.activeTabIndex
          });
          return (
            <li
              key={idx}
              className={listItemClassName}
              onClick={() => this.changeNavItem(tab, idx)}
            >
              {tab}
            </li>
          );
        })}
      </ul>
    );
  }
}

export default TabbedNav;
